import { render } from "./SystemFeatureFlagsPanel.vue?vue&type=template&id=647b7a5e"
import script from "./SystemFeatureFlagsPanel.vue?vue&type=script&lang=js"
export * from "./SystemFeatureFlagsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__